import {CategorieDto} from "@resources/resources";
import {ActivatedRoute} from "@angular/router";
import {Component} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {ArianeStore} from "@digicerba/common";
import {CategoriesStore} from "@common/store/categories.store";

@Component({
  selector: 'gestion-categories',
  templateUrl: './gestion.categories.component.html',
  host: {'class': 'page'}
})
export class GestionCategorieComponent {

  categories: Array<CategorieDto> = [];

  constructor(private arianeStore: ArianeStore, private translateService: TranslateService,
              private categoriesStore: CategoriesStore, private activatedRoute: ActivatedRoute) {
    this.initArianne();
  }

  private initArianne() {
    let arianeElements = [
      {
        libelle: "ARIANNE.module",
        route: "/"
      },
      {
        libelle: "ARIANNE.CATEGORIES.categories",
        route: "/categories/list"
      }
    ];

    this.arianeStore.updateElements(arianeElements);
  }

  ngOnInit() {
      this.categories = this.categoriesStore.getCategories();
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/src/app/pages/cerba/pages/categories/gestion-categories/gestion.categories.component.ts